<template>

  <div class="p-0 m-0 overflow-hidden"
    :style="firstLoad ? '' : 'background: #000000b8;position: fixed;z-index: 5000;    height: 100vh;top: 0px;bottom: 0px; '">
    <div class="m-content p-0 m-0 overflow-hidden" v-if="firstLoad">
      <div style="background-repeat:none;position: absolute;width: 100vw;height:100vh;filter: grayscale(1);z-index: 5;"
        :style="{ 'background-image': `url(./img/loaders/${loader}.jpg)`, 'background-size': `100% auto!important`, 'background-position': `center bottom` }">
      </div>
      <div id="overlay2" style="left: 0px;
    position: absolute;
    overflow: hidden;
       background-position: bottom;
    width: 100%;
    z-index:50; z-index: 10;
    background-size: cover;
    border-top: 1px solid red;
    " :style="`top:${100 - loadPercentage}%;height:${loadPercentage}%!important;`">

      </div>
      <div class="ocrloader">
        <em></em>
        <span></span>
      </div>
      <div id="overlay" class="rounded-s" style="left: 0px;
    position: absolute;
    overflow: hidden;
    width: 100%;z-index:7;

    " :style="`top:${100 - loadPercentage}%;background-size:100% auto!important;background-repeat:none;background-position:center bottom; height:${loadPercentage}%!important;background-image:url(./img/loaders/${loader}.jpg)`">
      </div>
      <div class="logo-large">
        <Icon class="img-fluid" name="logo" />
        <div class="card card-style">
          <div class="content">
            <h5 class="text-center font-700 text-yellow">
              {{ q }}
            </h5>
            <h3 class="text-center font-700 pb-3">
              {{ a }}
            </h3>
            <h6 class="text-center text-red">Warning: DrugWars is a game that involves fictional scenarios and elements
              related
              to drugs, alcohol, and violence. These themes are not to be taken lightly in real life.</h6>
          </div>
        </div>
      </div>

    </div>
    <div v-else class="m-content p-0 m-0 overflow-hidden" :style="firstLoad ? '' : 'background:transparent;'">
      <div class="pill">
        <div class="medicine">
          <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
        </div>
        <div class="side"></div>
        <div class="side"></div>
      </div>
    </div>
  </div>

</template>



<script>
import { mapActions } from 'vuex';
import dyk from '@/.././dyk.json';
import anon from '@/../anon.json';
import bella from '@/../bella.json';
export default {
  data() {
    return {
      canLogin: process.env.VUE_APP_DEV || false,
      a: "",
      dyk: dyk,
      anon: anon,
      bella: bella,
      loader:1,
      q: "Did You Know?"
    };
  },
  created() {
    this.setMessage()
    this.loader = Math.floor(Math.random() * Math.floor(46))+1
  },
  methods: {
    ...mapActions(['setLoadingPercentage']),
    setMessage() {
      const p = Math.floor(Math.random() * 3)
      if (p === 0) {
        this.q = "Bella Ramirez"
        this.a = '"' + bella[(Math.floor(Math.random() * Math.floor(bella.length)))] + '"'
      }
      else if (p === 1) {
        this.q = "Anonymous tip"
        this.a = '"' + anon[(Math.floor(Math.random() * Math.floor(anon.length)))] + '"'
      }
      else
        this.a = dyk[(Math.floor(Math.random() * Math.floor(dyk.length)))]

    }
  },
  computed: {
    server() {
      return this.$store.state.game.server;
    },
    loadPercentage() {
      return this.$store.state.ui.loadingPercentage;
    },
    firstLoad() {
      return this.$store.state.ui.firstLoad;
    },
  },
};
</script>

<style lang="less" scoped>
.logo-large {
  position: absolute;
  max-width: 90%;
  top: 30%;
  z-index: 10;
}

.m-content {
  position: relative;
  width: 100vw;
  left: 0px;
  top: 0px;
  height: 100vh;
  max-height: 100vh;
  background: #fff0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pill {
  background: #fff0;
  width: 15%;
  height: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transform: rotate(180deg);
  animation: spin 4s linear 0s infinite;
}

@keyframes spin {
  100% {
    transform: rotate(-540deg);
  }
}

.pill .side {
  background: #ffb700;
  position: relative;
  overflow: hidden;
  width: 6vmin;
  height: 9vmin;
  box-shadow: 0px 0px 5px rgb(255, 204, 0);
  border-radius: 6vmin 6vmin 0 0;
}

.pill .side+.side {
  background: #ffffff;
  border-radius: 0 0 6vmin 6vmin;
  border-top: 1vmin solid #bfbfbf;
  box-shadow: 0px 0px 5px rgb(255, 255, 255);
  animation: open 2s ease-in-out 0s infinite;
}

@keyframes open {

  0%,
  20%,
  80%,
  100% {
    margin-top: 0;
  }

  30%,
  70% {
    margin-top: 10vmin;
  }
}

.pill .side:before {
  content: "";
  position: absolute;
  width: 2vmin;
  height: 10vmin;
  bottom: 0;
  right: 1.5vmin;
  background: #fff2;
  border-radius: 1vmin 1vmin 0 0;
  animation: shine 1s ease-out -1s infinite alternate-reverse;
}

.pill .side+.side:before {
  bottom: inherit;
  top: 0;
  border-radius: 0 0 1vmin 1vmin;
}

.pill .side:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  border-radius: 6vmin 6vmin 0 0;
  border: 1.75vmin solid #00000022;
  border-bottom-color: #fff0;
  border-bottom-width: 0vmin;
  border-top-width: 1vmin;
  animation: shadow 1s ease -1s infinite alternate-reverse;
}

.pill .side+.side:after {
  bottom: inherit;
  top: 0;
  border-radius: 0 0 6vmin 6vmin;
  border-top-color: #fff0;
  border-top-width: 0vmin;
  border-bottom-width: 1vmin;
}

@keyframes shine {

  0%,
  46% {
    right: 1.5vmin;
  }

  54%,
  100% {
    right: 7.5vmin;
  }
}

@keyframes shadow {

  0%,
  49.999% {
    transform: rotateY(0deg);
    left: 0;
  }

  50%,
  100% {
    transform: rotateY(180deg);
    left: -3vmin;
  }
}

.medicine {
  position: absolute;
  width: calc(100% - 11vmin);
  height: calc(100% - 13vmin);
  background: #fff0;
  border-radius: 5vmin;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}



.medicine i {
  width: 1vmin;
  height: 1vmin;
  background: rgb(255, 255, 255);
  border-radius: 100%;
  position: absolute;
  box-shadow: 0px 0px 5px rgb(255, 255, 255);
  animation: medicine-dust 1.75s ease 0s infinite alternate;
}

.medicine i:nth-child(2n+2) {
  width: 1.4vmin;
  height: 1.4vmin;
  margin-top: -4vmin;
  margin-right: -4vmin;
  animation-delay: -0.2s;
  box-shadow: 0px 0px 5px rgb(255, 204, 0);
  background: rgb(255, 204, 0);
}

.medicine i:nth-child(3n+3) {
  width: 2vmin;
  height: 2vmin;
  margin-top: 4vmin;
  margin-right: 3vmin;
  animation-delay: -0.33s;
}

.medicine i:nth-child(4) {
  margin-top: -5vmin;
  margin-right: 4vmin;
  animation-delay: -0.4s;
}

.medicine i:nth-child(5) {
  margin-top: 5vmin;
  margin-right: -4vmin;
  animation-delay: -0.5s;
}

.medicine i:nth-child(6) {
  margin-top: 0vmin;
  margin-right: -3.5vmin;
  animation-delay: -0.66s;
}

.medicine i:nth-child(7) {
  margin-top: -2vmin;
  margin-right: 5vmin;
  animation-delay: -0.7s;
}

.medicine i:nth-child(8) {
  margin-top: 6vmin;
  margin-right: -1vmin;
  animation-delay: -0.8s;
}

.medicine i:nth-child(9) {
  margin-top: 4vmin;
  margin-right: -2vmin;
  animation-delay: -0.99s;
}

.medicine i:nth-child(10) {
  margin-top: -7vmin;
  margin-right: 2vmin;
  animation-delay: -1.11s;
}

.medicine i:nth-child(11) {
  margin-top: 6vmin;
  margin-right: 4vmin;
  animation-delay: -1.125s;
}

.medicine i:nth-child(12) {
  margin-top: -7vmin;
  margin-right: -2vmin;
  animation-delay: -1.275s;
}

.medicine i:nth-child(13) {
  margin-top: -1vmin;
  margin-right: 3vmin;
  animation-delay: -1.33s;
}

.medicine i:nth-child(14) {
  margin-top: -3vmin;
  margin-right: -1vmin;
  animation-delay: -1.4s;
}

.medicine i:nth-child(15) {
  margin-top: -1vmin;
  margin-right: -3vmin;
  animation-delay: -1.55s;
}

@keyframes medicine-dust {

  0%,
  100% {
    transform: translate3d(0vmin, 0vmin, -0.1vmin);
  }

  25% {
    transform: translate3d(0.25vmin, 5vmin, 0vmin);
  }

  75% {
    transform: translate3d(-0.1vmin, -4vmin, 0.25vmin);
  }
}


.ocrloader span::before {
  content: "";
  position: absolute;
  bottom: 0px;
  left: 45%;
  width: 10px;
  z-index: 0;
  height: 100%;
  background: green;
  box-shadow: 0 0 20px 5px green;
  clip-path: inset(0);
  animation:
    x 1s ease-in-out infinite,
    y 1s ease-in-out infinite;
  rotate: 90deg;
  top: 0px;
  z-index: 8;
}


@keyframes x {
  1% {
    rotate: 90deg;
    transform: translateX(100vh);
  }

  100% {
    rotate: 90deg;
    transform: translateX(-100vh);
  }
}

@keyframes y {
  33% {
    clip-path: inset(0 0 0 -50vh);
  }

  50% {
    clip-path: inset(0 0 0 0);
  }

  83% {
    clip-path: inset(0 -50vh 0 0);
  }

}
</style>